import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  TREQUEST_BulkSaveWashReceiveRequest,
  TREQUEST_BulkSaveWashSendRequest,
  TREQUEST_BulkWashSentQuantityRequest,
  TREQUEST_WashReceiveTransactionListingRequest,
  TREQUEST_WashReceiveTransactionUndo,
  TREQUEST_WashSendTransactionListingRequest,
  TREQUEST_WashSendTransactionUndo,
  TREQUEST_WashingReceiveBctxDataRequest,
  TREQUEST_WashingReceiveQuantityRequest,
  TREQUEST_WashingSentQuantityRequest,
  TREQUEST_WipByBctxRequest,
  TRESPONSE_BulkSaveWashReceive,
  TRESPONSE_BulkSaveWashSend,
  TRESPONSE_BulkWashSentQuantityResponse,
  TRESPONSE_VendorsResponse,
  TRESPONSE_WashReceiveTransactionListingResponse,
  TRESPONSE_WashSendTransactionListingResponse,
  TRESPONSE_WashingReceiveBctxDataResponse,
  TRESPONSE_WashingReceiveQuantity,
  TRESPONSE_WashingSentQuantity,
  TRESPONSE_WipByBctxResponse,
  TREQUEST_Vendors,
} from '@monorepo/types';
import { BulkCountAppEnvService } from './bulk-count-app.env.service';
import { CapacitorHttpService } from '../../capacitor/capacitor-http.service';

@Injectable({
  providedIn: 'root',
})
export class BulkCountAppDataService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  constructor(
    public http: HttpClient,
    public bulkCountAppEnvService: BulkCountAppEnvService,
    private capacitorHttpService: CapacitorHttpService,
  ) {}

  getVendorList(request: TREQUEST_Vendors) {
    const url = this.bulkCountAppEnvService.getEnvVar('VENDOR_LIST_BY_FACTORY_ID');
    return this.http.post<TRESPONSE_VendorsResponse>(url, request, this.httpOptions);
    // return of(vendorRes);
  }

  getSentCount(payload: TREQUEST_WashingSentQuantityRequest) {
    const url = this.bulkCountAppEnvService.getEnvVar('SENT_COUNT');
    return this.http.post<TRESPONSE_WashingSentQuantity>(url, payload, this.httpOptions);
    // return of(sentRes);
  }

  getBctxWiseSentQuantity(payload: TREQUEST_BulkWashSentQuantityRequest) {
    const url = this.bulkCountAppEnvService.getEnvVar('BCTX_WISE_SENT_QUANTITY');
    return this.http.post<TRESPONSE_BulkWashSentQuantityResponse>(url, payload, this.httpOptions);
    // return of(bulkWashSentQuantityResponse);
  }

  getBctxWiseWipQuantity(payload: TREQUEST_WipByBctxRequest) {
    const url = this.bulkCountAppEnvService.getEnvVar('BCTX_WISE_WIP_QUANTITY');
    return this.http.post<TRESPONSE_WipByBctxResponse>(url, payload, this.httpOptions);
    // return of(wipByBctxResponse);
  }

  saveBulkSendEvents(payload: TREQUEST_BulkSaveWashSendRequest) {
    const url = this.bulkCountAppEnvService.getEnvVar('BULK_SEND_SAVE_EVENT');
    return this.capacitorHttpService.post<TRESPONSE_BulkSaveWashSend>(url, payload);
  }

  getSendTransactionListing(payload: TREQUEST_WashSendTransactionListingRequest) {
    const url = this.bulkCountAppEnvService.getEnvVar('SEND_TRASACTION_LISTING');
    return this.http.post<TRESPONSE_WashSendTransactionListingResponse>(url, payload, this.httpOptions);
    // return of(washSendTransactionListingResponse);
  }

  getReceiveCount(payload: TREQUEST_WashingReceiveQuantityRequest) {
    const url = this.bulkCountAppEnvService.getEnvVar('RECEIVE_COUNT');
    return this.http.post<TRESPONSE_WashingReceiveQuantity>(url, payload, this.httpOptions);
    // return of(receiveRes);
  }

  getVendorsToBctxCombinationData(payload: TREQUEST_WashingReceiveBctxDataRequest) {
    const url = this.bulkCountAppEnvService.getEnvVar('VENDORS_TO_BCTX_COMBINATION_DATA');
    return this.http.post<TRESPONSE_WashingReceiveBctxDataResponse>(url, payload, this.httpOptions);
    // return of(washingReceiveBctxDataResponse);
  }

  saveBulkReceiveEvents(payload: TREQUEST_BulkSaveWashReceiveRequest) {
    const url = this.bulkCountAppEnvService.getEnvVar('BULK_RECEIVE_SAVE_EVENT');
    return this.capacitorHttpService.post<TRESPONSE_BulkSaveWashReceive>(url, payload);
  }

  getReceivesTransactionListing(payload: TREQUEST_WashReceiveTransactionListingRequest) {
    const url = this.bulkCountAppEnvService.getEnvVar('RECEIVE_TRASACTION_LISTING');
    return this.http.post<TRESPONSE_WashReceiveTransactionListingResponse>(url, payload, this.httpOptions);
    // return of(washReceiveTransactionListingResponse);
  }

  undoSendTransaction(payload: TREQUEST_WashSendTransactionUndo) {
    const url = this.bulkCountAppEnvService.getEnvVar('SEND_TRANSACTION_UNDO');
    return this.http.post<void>(url, payload, this.httpOptions);
  }

  undoReceiveTransaction(payload: TREQUEST_WashReceiveTransactionUndo) {
    const url = this.bulkCountAppEnvService.getEnvVar('RECEIVE_TRANSACTION_UNDO');
    return this.http.post<void>(url, payload, this.httpOptions);
  }
}
